var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 7.81315C18.3327 7.28815 18.0827 6.79648 17.666 6.47982L10.9993 1.47982C10.7109 1.26345 10.36 1.14648 9.99935 1.14648C9.63873 1.14648 9.28784 1.26345 8.99935 1.47982L2.33268 6.47982C2.12569 6.63506 1.95768 6.83637 1.84197 7.0678C1.72626 7.29922 1.66602 7.55441 1.66602 7.81315M18.3327 7.81315V16.1465C18.3327 16.5885 18.1571 17.0124 17.8445 17.325C17.532 17.6376 17.108 17.8132 16.666 17.8132H3.33268C2.89065 17.8132 2.46673 17.6376 2.15417 17.325C1.84161 17.0124 1.66602 16.5885 1.66602 16.1465V7.81315M18.3327 7.81315L10.8577 12.5632C10.6004 12.7243 10.3029 12.8098 9.99935 12.8098C9.69575 12.8098 9.39829 12.7243 9.14102 12.5632L1.66602 7.81315",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpen);
export default __webpack_public_path__ + "static/media/mail_open.f52ece321f22be623dd240f588a3bb24.svg";
export { ForwardRef as ReactComponent };